module.exports = __webpack_public_path__ + "static/media/searchOutlinedIcon.362b1a8b.svg";